import { Navigate, useLocation } from 'react-router-dom';

export function RedirectWithTarget({ to }: { to: string }) {
    const location = useLocation();
    const target = `${location.pathname}${location.search}`;
    return <Navigate to={`${to}?target=${target}`} replace />;
}
